export default function getRotatedOffset(offsetX: number, offsetY: number, rad: number) {
  return {
    x: offsetX * Math.cos(rad) - offsetY * Math.sin(rad),
    y: offsetX * Math.sin(rad) + offsetY * Math.cos(rad)
  };
};